<!-- <template>
  <div class="head" :class="{ headS: scrollTop >= 200 }">
    <img  v-if="(scrollTop < 200)" src="/static/image/logo@2x.png" class="logo" />
    <img  v-else-if="(scrollTop >= 200)" src="/static/image/logo_head.png" class="logo" />
    <div class="navs">
      <div
        class="item"
        v-for="(item, index) in navs"
        :key="index"
        :class="{ selected: index == headerIndex, itemT: scrollTop >= 200,selectedT: (scrollTop >= 200 && index == headerIndex )}"
        @click="changeMenu(item, index)"
      >
        {{ item.name }}
        <div class="line-panel" v-if="index == headerIndex">
          <div class="line" :class="{ lineT: scrollTop >= 200 }"></div>
        </div>
      </div>
    </div>
  </div>
</template> -->



<template>
  <div class="head headS" >
   
    <img  src="/static/image/logo_head.png" class="logo" />
    <div class="navs">
      <div
        class="item itemT"
        v-for="(item, index) in navs"
        :key="index"
        :class="{ selected: index == headerIndex ,selectedT:  index == headerIndex }"
        @click="changeMenu(item, index)"
      >
        {{ item.name }}
        <div class="line-panel"  v-if="index == headerIndex">
          <div class="line" ></div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      localIndex: -1,
      navs: [
        {
          name: "首页",
          path: "index",
        },
        {
          name: "核心技术",
          path: "hxjs",
        },
        {
          name: "产品中心",
          path: "cpzx",
        },
        {
          name: "新闻中心",
          path: "news",
        },
        {
          name: "服务支持",
          path: "support",
        },
        {
          name: "加入我们",
          path: "join",
        },
        {
          name: "关于晨新",
          path: "about",
        }
      ],
    };
  },
  created() {
    this.localIndex = window.localStorage.getItem("index");
  },
  computed: {
    ...mapState(["headerIndex", "scrollTop"]),
  },
  mounted() {
    if (this.localIndex) {
      this.changeHeaderIndex(this.localIndex);
    }
  },
  methods: {
    ...mapMutations(["changeHeaderIndex"]),
    changeMenu(item, index) {
      this.$router.push({ name: item.path });
      window.localStorage.setItem("index", index);
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes gradient-animationT {
  0% { background-color: rgba(255, 255, 255, 0); } /* 初始状态为红色 */
  100% { background-color: rgba(255, 255, 255, 1); } /* 结束状态为黄色 */
}

.head {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: rgba(255, 255, 255, 0);
  
  .logo {
    position: absolute;
    width: 130px;
    left: 360px;
    top: 10px;
    height: 54px;
  }
  .navs {
    position: absolute;
    left: 673px;
    height: 100%;
    display: flex;
    align-items: center;
    .item {
      font-size: 22px;
      cursor: pointer;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      height: 72px;
      line-height: 72px;

      color: #ffffff;
      position: relative;
      margin-right: 56px;
      .line-panel {
        position: absolute;
        bottom: 0;
        height: 4px;
        width: 100%;
        display: flex;
        justify-content: center;
        .line {
          width: 32px;
          height: 4px;

          background: #00479e;
          border-radius: 10px;
        }

     
      }
    }
    .itemT {
      color: #333333;
    }
    .selected {
      font-size: 22px;
      font-weight: bold;
      color: #ffffff;
    }
    .selectedT {
      font-size: 22px;
      font-weight: bold;
      color: #00479e;
    }
  }
}

.headS {
  background-color: rgba(255, 255, 255, 1);
  animation: gradient-animationT 0.2s linear 1;
  box-shadow: 0px 0px 10px 1px rgba(0,0,0,0.1);
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue